import React from 'react';
import { Link } from 'react-router-dom';
export function CommerceLinks() {
  return <section className="py-12 bg-subtle-gray/30 text-center" data-id="element-750">
      <div className="max-w-4xl mx-auto px-4" data-id="element-751">
        <p className="text-gray-warm font-bold mb-4 uppercase tracking-wide" data-id="element-752">
          Also Serving Nearby Communities
        </p>
        <div className="flex flex-wrap justify-center gap-4" data-id="element-753">
          {['Walled Lake', 'Novi', 'Waterford', 'Farmington Hills'].map((area, idx) => <Link key={idx} to={`/${area.toLowerCase().replace(/\s+/g, '-')}-martial-arts`} className="text-ink hover:text-storm-red transition-colors font-medium" data-id="element-754">
                {area}
              </Link>)}
        </div>
      </div>
    </section>;
}